import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Send } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import emailjs from '@emailjs/browser';

const ContatoPage = () => {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    assunto: '',
    mensagem: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      return {
        ...prev,
        [name]: value
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    setIsSubmitting(true);

    try {
      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_CONTACT,
        {
          nome: formData.nome,
          email: formData.email,
          assunto: formData.assunto,
          mensagem: formData.mensagem
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );

      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_AUTORESPONSE,
        {
          nome: formData.nome,
          email: formData.email,
          assunto: formData.assunto,
          mensagem: formData.mensagem
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );

      toast.success('Mensagem enviada com sucesso!');

      setFormData({
        nome: '',
        email: '',
        assunto: '',
        mensagem: ''
      });
    } catch (error) {
      toast.error('Erro ao enviar mensagem');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen pt-24 pb-16 px-6">
      <div className="max-w-[1400px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-14"
        >
          <h1 className="font-heading text-5xl md:text-6xl font-bold text-text-primary mb-6">
            Entre em Contato
          </h1>

          <p className="text-lg md:text-xl text-text-secondary max-w-3xl mx-auto leading-relaxed">
            Estamos aqui para ajudar. Envie sua mensagem e responderemos o
            mais breve possível.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="max-w-3xl mx-auto bg-white rounded-2xl shadow-sm p-8 md:p-12"
        >
          <h2 className="font-heading text-4xl font-bold text-center text-text-primary mb-10">
            Envie sua Mensagem
          </h2>

          <form onSubmit={handleSubmit} className="space-y-7">
            <div>
              <label className="block text-lg text-text-primary mb-3">
                Nome Completo
              </label>
              <input
                type="text"
                name="nome"
                value={formData.nome}
                onChange={handleChange}
                className="w-full h-14 rounded-xl border border-gray-200 px-4 outline-none focus:ring-2 focus:ring-accent/30"
                required
              />
            </div>

            <div>
              <label className="block text-lg text-text-primary mb-3">
                E-mail
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full h-14 rounded-xl border border-gray-200 px-4 outline-none focus:ring-2 focus:ring-accent/30"
                required
              />
            </div>

            <div>
              <label className="block text-lg text-text-primary mb-3">
                Assunto
              </label>
              <input
                type="text"
                name="assunto"
                value={formData.assunto}
                onChange={handleChange}
                className="w-full h-14 rounded-xl border border-gray-200 px-4 outline-none focus:ring-2 focus:ring-accent/30"
                required
              />
            </div>

            <div>
              <label className="block text-lg text-text-primary mb-3">
                Mensagem
              </label>
              <textarea
                name="mensagem"
                value={formData.mensagem}
                onChange={handleChange}
                rows="6"
                className="w-full rounded-xl border border-gray-200 px-4 py-4 outline-none resize-none focus:ring-2 focus:ring-accent/30"
                required
              />
            </div>

            <Button
              type="submit"
              disabled={isSubmitting}
              className="w-full bg-accent text-white hover:bg-accent/90 rounded-full h-14 text-lg shadow-sm"
            >
              <Send className="w-5 h-5 mr-2" />
              {isSubmitting ? 'Enviando...' : 'Enviar Mensagem'}
            </Button>
          </form>
        </motion.div>
      </div>
    </div>
  );
};

export default ContatoPage;